/**
 * Tarih, saat ve sayı gösterimi — TEK kapı (CLOS-105 `[066]`).
 *
 * ### Neden tek kapı
 *
 * Kartın kriteri: *"tarih, saat, sayı ve çoğul metinleri AYNI LOCALE ile TUTARLI
 * gösterilir."* Her ekran kendi `toLocaleDateString` çağrısını yazsaydı iki ekran aynı
 * tarihi farklı gösterirdi — biri `09.08.2026`, diğeri `9 Ağustos 2026`.
 *
 * ⚠ Locale değişikliği SAKLANAN veriyi değiştirmez, yalnız gösterimi (kartın runtime
 * koşulu). Bu yüzden bu dosyada hiçbir yazma yolu yok.
 */

/** Geçersiz girdide boş metin: ekranda `Invalid Date` görmek kullanıcıya bir şey söylemez. */
function tarihNesnesi(value: Date | string | number): Date | null {
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** Yalnız gün: `9 Ağustos 2026`. */
export function formatDate(value: Date | string | number, locale: string): string {
  const d = tarihNesnesi(value);
  if (!d) return "";
  return new Intl.DateTimeFormat(locale, { dateStyle: "long" }).format(d);
}

/** Gün ve saat: `9 Ağustos 2026 14:05`. */
export function formatDateTime(value: Date | string | number, locale: string): string {
  const d = tarihNesnesi(value);
  if (!d) return "";
  return new Intl.DateTimeFormat(locale, { dateStyle: "long", timeStyle: "short" }).format(d);
}

export function formatNumber(value: number, locale: string): string {
  if (!Number.isFinite(value)) return "";
  return new Intl.NumberFormat(locale).format(value);
}

/**
 * Çoğul metin.
 *
 * ⚠ Türkçede sayıdan sonra çoğul EKİ KULLANILMAZ ("3 sözleşme", "3 sözleşmeler" değil).
 * `Intl.PluralRules` Türkçe için `one`/`other` ayrımı verse de doğru ürün davranışı iki
 * biçimi de aynı yazmaktır; bu yüzden çağıran iki biçim verir ve locale kuralı KARAR
 * VERİR. İngilizce eklendiğinde aynı çağrı doğru çalışır.
 */
export function formatPlural(
  count: number,
  locale: string,
  forms: { one: string; other: string },
): string {
  const kural = new Intl.PluralRules(locale).select(count);
  return `${formatNumber(count, locale)} ${kural === "one" ? forms.one : forms.other}`;
}
